module.exports = __webpack_public_path__ + "static/img/driblab_color.45db83d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/driblab_color.png
// module id = EiMx
// module chunks = 94